/** Pushed/requested via the notification hub's `Request` invoke (requestType = CountSummary). */
export class NotificationCountSummaryDto {
  total = 0;
  recent = 0;
  unread = 0;
}
